import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getMilestones
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: true,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      // NOTE: we only want to sort the options loaded in from the BE
      // Any user defined options should retain the sort order in which they were entered
      const options = this.options.map(el => el.name).sort()
      const optionsWithHardCodedValues = options.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedValues) ]
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const params = {
            school: this.school,
            returnFields: '_id,name',
          }
          const data = await getMilestones(params) || {}
          this.options = Object.values(data)
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
}
